import { internationalTelephoneAreaCodeList } from "project-config/constants";
import { useEffect, useState } from "react";

export function useAreaCodeOptions() {
  const [areaCodeOptions, setAreaCodeOptions] =
    useState<{ label: string; value: string }[]>();

  useEffect(() => {
    const areaCodeOptions = internationalTelephoneAreaCodeList.map((item) => ({
      label: `${item.area} + ${item.number}`,
      value: item.number,
    }));
    setAreaCodeOptions(areaCodeOptions);
  }, []);
  return {
    areaCodeOptions,
  };
}
